import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Container from "@material-ui/core/Container";
import Header from "components/Header";
import ImageContainer from "components/ImageContainer";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import mifiOne from "images/device1.png";
import baseStationImage from "images/device2.png";
import CPEImage from "images/device3.png";

import MiFiTable from "containers/MiFiTable";
import BTSEndTable from "containers/BTSEndTable";
import CPEEndTable from "containers/CPEEndTable";
import Chart from "containers/Chart";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    minHeight: 188,
    textAlign: "center",
    color: theme.palette.text.secondary,
    padding: "0 16px",
    margin: "7px 0",
  },
  logo: {
    maxHeight: "52px",
    objectFit: "contain",
    height: "100%",
  },
  logoBS: {
    maxHeight: "80px",
  },
  imageContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-end",

    marginRight: "20px",
  },
  imageContentLabel: {
    padding: "20px 0 0 0",
  },
  customPaperInfo: {
    margin: "0 0 15px 0",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  title: {
    textAlign: "center",
    fontSize: "12px",
    color: "#000",
    fontWeight: 700,
    padding: "32px 0"
  },
}));

export default function App() {
  const classes = useStyles();

  return (
    <Container fixed>
      <Header />
      <div className={classes.root}>
        <Grid container spacing={2} alignItems="stretch">
          <Grid item xs={6}>
            <Paper className={`${classes.paper}`}>
              <ImageContainer label="MiFi" marginBottom="-20px">
                <img className={classes.logo} src={mifiOne} alt="MiFi" />
              </ImageContainer>
              <MiFiTable />
            </Paper>
            <Paper className={classes.paper}>
              <Chart />
            </Paper>
          </Grid>
          <Grid item xs={6}>
            <Paper className={`${classes.paper}`}>
              <ImageContainer label="Fixed Wireless">
                <div className={classes.imageContent}>
                  <img
                    className={`${classes.logo} ${classes.logoBS}`}
                    src={baseStationImage}
                    alt="Base Station"
                  />
                  <span className={classes.imageContentLabel}>
                    Base Station
                  </span>
                </div>
                <div className={classes.imageContent}>
                  <img className={classes.logo} src={CPEImage} alt="CPE" />
                  <span className={classes.imageContentLabel}>CPE</span>
                </div>
              </ImageContainer>
              <Typography className={classes.title} component="div">
                Fixed Wireless Cost (Default values populated by Cambium)
              </Typography>
              <BTSEndTable offBottomSpacing={false}/>
              <CPEEndTable />
            </Paper>
          </Grid>
        </Grid>
      </div>
    </Container>
  );
}
